/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class TOOLBOX_DETAIL_DISTANCE extends Component {
  state = {};

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props

    //content
    return (
      <section className="container_light margin_bottom background_grey_light outline_black">
        <p className="text_bold">{dict?.["Elevation"]?.[language]}</p>
        <p className="text_small">
          {
            dict?.[
              "Measure elevation samples of the cross section along the line"
            ]?.[language]
          }
        </p>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(TOOLBOX_DETAIL_DISTANCE);
